export default "__VITE_ASSET__D7up5fij__"